import { Directive, effect, ElementRef, inject, input, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Modal } from '../services/modal';

type axis = 'height' | 'width' | 'full';

@Directive({
  selector: '[appBiggen]',
  host: {
    '(click)': 'onClick()',
  }
})
export class Biggen {
  private platformId = inject(PLATFORM_ID);
  private modal = inject(Modal);
  private el = inject(ElementRef);
  private active = false;
  private prevScroll = 0;
  private img: HTMLImageElement;

  appBiggen = input({ axis: 'width', size: '' });

  setCommon = () => {
    this.img.style.position = this.active ? 'absolute' : '';
    this.img.style.top = this.active ? `${window.scrollY}px` : '';
    this.img.style.left = this.active ? '0px' : '';
    this.img.style.zIndex = this.active ? '100' : '';
    this.img.style.cursor = this.active ? 'zoom-out' : 'zoom-in';
  }

  private setHeight = () => {
    this.setCommon();
    this.img.style.height = this.active ? `100%` : `${this.appBiggen().size}`;
  }

  private setWidth = () => {
    this.setCommon();
    this.img.style.width = this.active ? `100%` : `${this.appBiggen().size}`;
  }

  private setFull = () => {
    this.setCommon();
    this.img.style.width = this.active ? `min(100dvh, 100dvw)` : `${this.appBiggen().size}`;
    this.img.style.position = this.active ? 'fixed' : '';
    this.img.style.top = this.active ? '0px' : '';
  }

  setAxis = (axis: string) => {
    if (isPlatformBrowser(this.platformId)) {
      switch (axis) {
        case 'height':
          this.setHeight();
          break;
        case 'width':
          this.setWidth();
          break;
        default:
          this.setFull();
          break;
      }
    }
  }

  assignGrow = () => {
    const axis = this.appBiggen().axis;
    this.active = !this.active;
    this.setAxis(axis);
    if (!this.active) {
      window.scrollTo(0, Math.floor(this.prevScroll));
    } else {
      this.prevScroll = window.scrollY;
    }
    this.modal.toggle(this.active);
  }

  onClick = () => {
    if (isPlatformBrowser(this.platformId)) {
      this.assignGrow();
    }
  }

  constructor() {
    this.img = this.el.nativeElement as HTMLImageElement;
    this.img.onload = () => {
      this.setAxis(this.appBiggen().axis);
      this.img.style.display = 'inline';
    };

    effect(() => {
      if (!this.modal.show()) {
        this.active = false;
        this.setAxis(this.appBiggen().axis);
      }
    });
  }
}
